<template>
  <el-dialog width="420px" title=""  class="dialogClass" :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="dissolutionVisible">
    <div class="details">
      <div class="dialogTilte">解散企业</div>
      <el-form    ref="currencyForm"   v-loading="loading"    label-position="right"   label-width="0px"  :model="currencyForm"  :rules="currencyFormRules">
        <div class="tips">是否确认解散企业?解散企业后该企业内所有数据不可复原。若确认解散，请在下方输入框中输入delete并继操作。</div>
        <el-form-item prop="code" label="">
          <el-input type="text" v-model="currencyForm.code"    placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button  :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认解散</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'dissolution',
  props: {
    dissolutionVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyForm:{
        code:'',
      },
      currencyFormRules:{
        code:[{ required: true, message: '请输入', trigger: 'blur'}],
      },



    }
  },

  created() {

  },
  computed: {
    ...mapState(['webUserInfo']),

  },
  mounted() {

  },
  methods: {

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          this.activeStep = 3
          // let postDataInfo = {
          //   file:this.currencyForm.file
          // }
          // this.BtnDisabled = true
          // clipUpload(postDataInfo).then(res => {
          //   if (res.code === 0) {
          //     this.$message({
          //       message: '新增成功',
          //       type: 'success',
          //       duration: 1000,
          //       onClose: () => {
          //         this.BtnDisabled = false
          //         this.$emit('success')
          //         this.$emit('update:dissolutionVisible', false)
          //       }
          //     })
          //   }else{
          //     this.BtnDisabled = false
          //   }
          // }).catch((e) => {
          //   this.BtnDisabled = false
          // })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:dissolutionVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}

</style>
